var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentPage == 2)?_c('div',[_c('LeituraMateriais',{attrs:{"isBusy":_vm.isBusy,"model":_vm.model,"detalheMaterial":"","hideMateriaisGenerico":"","withoutTitle":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }